module.exports = __webpack_public_path__ + "static/media/icon-delete.4576db51.svg";